import {
  SetLoadingActionType,
  SET_LOADING,
  SetErrorActionType,
  SET_ERROR,
} from './types';

export const setLoading = (
  isLoading: boolean,
  message?: string
): SetLoadingActionType => ({
  type: SET_LOADING,
  isLoading,
  message,
});

export const setError = (
  hasError: boolean,
  errorMessage?: string
): SetErrorActionType => ({
  type: SET_ERROR,
  hasError,
  errorMessage,
});
